module.exports = __webpack_public_path__ + "static/media/comment.d992e7e5.svg";